
<script>
import ReportingApi from "@/services/reporting-api";


/**
 * Reporting component
 */

export default {

    props: {
        firstDay:{
            type:String,
            default:null
        },
        lastDay:{
            type:String,
            default:null
        },
        campaignId:{
            type:Number,
            default:null
        }
    },
  mounted(){

    this.getTracking()

    this.selectAllKeys()
 
  },

  data() {
    return {
      trackingList: [],
      csvGeneratedList: [],
      pagemodel: {currentPage : 1, perPage :5, totalRows: 0},
      csvGeneratedPagemodel: {currentPage : 1, perPage :10, totalRows: 0},
      isGetTrackingStarting: false,
      isGetCsvGenerated: false,
      start:this.firstDay,
      end:this.lastDay,

        fields: [
            { key:"timeStamp", label: "", thStyle:"min-width:150px"},
            { key:"name", label: " ", thStyle:"min-width:100px"},
            { key:"age", label: "", thStyle:"min-width:70px"},
            { key:"phone", label: "", thStyle:"min-width:70px"},
            { key:"address", label: "", thStyle:"min-width:140px"},
            { key:"email", label: "", thStyle:"min-width:200px"},
            { key:"gender", label: "", thStyle:"min-width:100px"},
            { key:"customFields", label: "", thStyle:"width:170px"},
            { key:"customDropDown", label: "", thStyle:"min-width:100px"},
            // { key:"ipAddress", label: "", thStyle:"min-width:100px"},
            { key:"userAgent", label: "", thStyle:"min-width:28%"},
            
            ],

        csvGeneratedFields: [
            { key:"timeStamp", label: "timeStamp", thStyle:"min-width:70px"},
            { key:"userName", label: "", thStyle:"min-width:70px"},
            { key:"csvHeaders", label: "", thStyle:"min-width:150px"},
            { key:"generateStatus", label: " ", thStyle:"min-width:150px"},
            { key:"linesCount", label: "", thClass:"text-right", tdClass:"text-right align-middle", thStyle:"min-width:150px"},
            { key:"action", label: "", thStyle:"min-width:60px"}
            
            ],

            campaignTableHeaders: [
                { key: "timeStamp", text: this.$t("campaign.table.head.timeStamp") },
                { key: "name", text: this.$t("campaign.table.head.nameUser") },
                { key: "age", text: this.$t("campaign.table.head.age") },
                { key: "phone", text: this.$t("campaign.table.head.phone") },
                { key: "address", text: this.$t("campaign.table.head.address") },
                { key: "email", text: this.$t("campaign.table.head.email") },
                { key: "gender", text: this.$t("campaign.table.head.gender") },
                { key: "ipAddress", text: this.$t("campaign.table.head.ipAddress") },
                { key: "userAgent", text: this.$t("campaign.table.head.userAgent") },
                { key: "customFields", text: this.$t("campaign.table.head.customFields") },
                { key: "customDropDown", text: this.$t("campaign.table.head.customDropDown") },
            ],

        selectedOptions: new Set(),

      showModal: false,

    };
  },

  watch:{
    start:function(){
      if(this.start && this.end || (!this.start && !this.end)){
        this.getTracking()
      }
    },
    
    end:function(){
      if(this.start && this.end || (!this.start && !this.end)){
        this.getTracking()
      } 
    },
    campaignId:function(){
        this.getTracking()
    },

    },

  methods: {

    selectAllKeys() {
        this.campaignTableHeaders.forEach(cth => this.selectedOptions.add(cth.key));
    },

    isChecked(item){
            return this.selectedOptions.has(item.key) ? 1 : 0
        },

    handleCheckboxChange(item) {
        if (this.selectedOptions && this.selectedOptions.has(item.key)) {
            this.selectedOptions.delete(item.key);
        } else {
            this.selectedOptions.add(item.key);
        }
    },


    downloadCSV(csvGeneratedId){
        ReportingApi.downloadCSV(csvGeneratedId)
    },

    generateStatusToLabel(status){
      switch(status){
        case 0: return 'Générations en cours';
        case 1: return 'Erreur';
        case 2:return 'Générations Terminée';
        default: return '_'
      }
    },

    generateStatusToColor(status){
     
      switch(status){
        case 0: return 'warning';
        case 1: return 'danger';
        case 2:return 'success';
        default: return '_'
      }
    },


    getCsvGenerated(){
        this.isGetCsvGenerated=true
        ReportingApi.getCsvGenerated(this.csvGeneratedPagemodel.currentPage, this.csvGeneratedPagemodel.perPage, this.campaignId).then(
                (result) => {
                    if(result){
                        this.csvGeneratedList=result.list;
                        this.csvGeneratedPagemodel.totalRows = result.total;
                        this.csvGeneratedPagemodel.currentPage = result.page;
                        this.csvGeneratedPagemodel.perPage = result.pageSize;
                        this.csvGeneratedPagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetCsvGenerated=false
            })
    },

    exportCollectedData() {

        if(this.pagemodel.totalRows == 0){
            return;
        }

       ReportingApi.exportCollectedData(this.start, this.end, this.campaignId,  Array.from(this.selectedOptions).join(", "));
       this.showModal = false

    },

    openExportModal(){
        this.showModal = true
    },


    getTracking(){
            this.isGetTrackingStarting=true
            ReportingApi.getTracking(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,null,this.campaignId).then(
                (result) => {
                    if(result){
                        this.trackingList=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetTrackingStarting=false
            })
        },

  }
};
</script>

<template>

    <div class="card">
        <div class="card-body ">
            <b-tabs  nav-class="nav-tabs-custom" content-class="p-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">
                  <!--datails Customer -->
                  <b-tab  active class="border-0"  lazy @click="getTracking();">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                        <i class="fas fa-info-circle  font-size-16 pr-2"/>
                        </span>
                        <span class="d-none d-sm-inline-block font-size-16">{{ $t("reporting.customer.tracking") }} </span>
                    </template>
                    
                    <div class="row">
                        <div class="col-12 col-lg-11"></div>
                        
                        <div class="col-12 col-lg-1 mt-2 mt-lg-0 text-right">
                            <b-button  variant="outline-primary"    @click.prevent="openExportModal()"    class="float-right mb-0 p-1"    size="md"   >
                                <i class="fas fa-file-excel font-size-14 m-0 p-0 font-weight-bold align-middle"></i> 
                                <span class="font-weight-bold text-uppercase ml-2">
                                    {{ $t('buttons.export') }}
                                </span>
                            </b-button>
                        </div>
                        </div>





                    <div  class="row mt-4 mb-4">
                    
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-4 ">
                        <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                            <b-form-datepicker
                            v-model="start"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12  pl-lg-4 ">
                        <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                            <b-form-datepicker
                            v-model="end"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright                         
                            hide-header
                            ></b-form-datepicker>
                        </b-form-group>
                        </div>
                    </div>
                    <div class="table-responsive mb-0" style="max-height:39em;min-height:39em"  >
                        <b-table
                        :busy="isGetTrackingStarting"
                        :striped="true"
                        :small="true"
                        :hover="true"
                        :items="trackingList"
                        :fields="fields"
                        :perPage="pagemodel.perPage"
                        thead-style="display: none"
                        >
                        <template v-slot:table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:head(timeStamp)>
                        {{ $t("campaign.table.head.timeStamp") }} 
                        </template>
                        <template v-slot:head(campaignName)>
                        {{ $t("campaign.table.head.name") }} 
                        </template>
                        <template v-slot:head(name)>
                        {{ $t("campaign.table.head.nameUser") }} 
                        </template>
                        <template v-slot:head(age)>
                        {{ $t("campaign.table.head.age") }} 
                        </template>
                        <template v-slot:head(address)>
                        {{ $t("campaign.table.head.address") }} 
                        </template>
                        <template v-slot:head(phone)>
                        {{ $t("campaign.table.head.phone") }} 
                        </template>
                        <template v-slot:head(email)>
                        {{ $t("campaign.table.head.email") }} 
                        </template>
                        <template v-slot:head(ipAddress)>
                        {{ $t("campaign.table.head.ipAddress") }} 
                        </template>
                        <template v-slot:head(userAgent)>
                        {{ $t("campaign.table.head.userAgent") }} 
                        </template>
                        <template v-slot:head(gender)>
                        {{ $t("campaign.table.head.gender") }} 
                        </template>
                        <template v-slot:head(customDropDown)>
                        {{ $t("campaign.table.head.customDropDown") }} 
                        </template>
                        <template v-slot:head(customFields)>
                        {{ $t("campaign.table.head.customFields") }} 
                        </template>

                        <template v-slot:cell(name)="{item}">
                            <div>{{!item.name ? "_" : item.name}}</div>
                        </template>

                        <template v-slot:cell(age)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>
                        <template v-slot:cell(phone)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>
                        <template v-slot:cell(email)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        <template v-slot:cell(userAgent)="{item}">
                            <div><code>IP: {{!item.ipAddress ? "_" : item.ipAddress}}</code></div>
                            <div><code>{{!item.userAgent ? "_" : item.userAgent}}</code></div>
                        </template>

                        <template v-slot:cell(timeStamp)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        <template v-slot:cell(gender)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        <template v-slot:cell(customFields)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        <template v-slot:cell(customDropDown)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        <template v-slot:cell(address)="{value}">
                            <span>{{!value ? "_" : value}}</span>
                        </template>

                        </b-table>
                        <span v-if="!isGetTrackingStarting && !trackingList.length" class="d-flex justify-content-center m-4 text-secondary" >{{$t("reporting.supplier.emptyTable") }}</span>
                    </div>
                   
                    <!-- Pagination -->
                    <div class="row pt-3 pl-2 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="getTracking()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[5,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getTracking()" :disabled="isGetTrackingStarting" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                    

                  </b-tab>

                   <!-- Note-->
                <b-tab  class="border-0 "  lazy @click="getCsvGenerated()">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                        <i class="fas fa-sticky-note font-size-16 pr-2"/>
                        </span>
                        <span class="d-none d-sm-inline-block font-size-16">{{ $t("reporting.customer.csvGenerated") }}  </span>
                    </template>


                    <div class="table-responsive mb-0 mt-4" style="max-height:31em;min-height:31em"  >
                        <b-table
                        :busy="isGetCsvGenerated"
                        :striped="true"
                        :small="true"
                        :hover="true"
                        :items="csvGeneratedList"
                        :fields="csvGeneratedFields"
                        :perPage="csvGeneratedPagemodel.perPage"
                        thead-style="display: none"
                        >
                        <template v-slot:table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:head(timeStamp)>
                        {{ $t("campaign.table.head.timeStamp") }} 
                        </template>
                        <template v-slot:head(linesCount)>
                        {{ $t("campaign.table.head.linesCount") }} 
                        </template>
                        <template v-slot:head(userName)>
                        {{ $t("campaign.table.head.nameUser") }} 
                        </template>
                        <template v-slot:head(generateStatus)>
                        {{ $t("campaign.table.head.generateStatus") }} 
                        </template>
                        <template v-slot:head(csvHeaders)>
                        {{ $t("campaign.table.head.csvHeaders") }} 
                        </template>

                      
                        <template v-slot:cell(csvHeaders)="{ value }">
                            <b-badge v-for="(header, index) in value.split(';')" :key="index" class="font-size-11 mr-1">
                            {{ header }}
                            </b-badge>
                        </template>

                        <template v-slot:cell(generateStatus)="{ value }">
                            <b-badge :variant="generateStatusToColor(value)"  class="font-size-11 mr-1">
                                {{ generateStatusToLabel(value) }}
                            </b-badge>
                            <img v-if="value == 0"  alt="refresh"  width="20px" class="mr-2"  src="@/assets/icons/refresh-warning.svg" style="cursor: pointer;" @click="getCsvGenerated()" />
                        </template>

                        <template v-slot:cell(action)="{ item }">
                            <img v-if="item.generateStatus == 2"  alt="download"  width="20px" class="mr-2"  src="@/assets/icons/download.svg" style="cursor: pointer;" @click="downloadCSV(item.id)" />
                        </template>

                        </b-table>
                        <span v-if="!isGetCsvGenerated && !csvGeneratedList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }}</span>
                    </div>
                    <!-- Pagination -->
                    <div class="row pt-3 pl-2 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="getCsvGenerated()"  v-model="csvGeneratedPagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{csvGeneratedPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="csvGeneratedPagemodel.currentPage" :per-page="csvGeneratedPagemodel.pageSize" :total-rows="csvGeneratedPagemodel.totalRows" @input="getCsvGenerated()" :disabled="isGetCsvGenerated" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                  
                  </b-tab>
              </b-tabs>

    </div>


    <b-modal
        v-model="showModal"
        hide-header
        hide-footer
        centered
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        size="md">

        <div class="text-center">
            <img  alt="View details"  width="180px" class="mr-2"  src="@/assets/icons/danger-circle-warning.svg" />
        </div>


            <div class="text-center font-size-20 font-weight-bold mt-3 ">
                {{ $t("reporting.dataExport") }}
            </div>

            <div v-if="this.pagemodel.totalRows > 0" >
                <div class="text-center font-size-16 mt-3">
                    {{ $t("reporting.export") }} <strong>{{this.pagemodel.totalRows}}</strong> 
                    {{ $t("reporting.textExport") }}
                </div>

                <div class=" mt-4 row pl-4  ml-5">

                    <div v-for="row in campaignTableHeaders" :key="row.key"  class="col-6 d-flex mb-2">
                        <div class="form-group d-flex align-items-center justify-content-center">
                                <b-form-checkbox  
                                :id="'checkbox_' + row.key"
                                value="1"
                                unchecked-value="0"
                                class="custom-checkbox custom-checkbox-success mb-0 mt-0"    
                                :checked="isChecked(row)"
                                @change="handleCheckboxChange(row)"
                                ></b-form-checkbox> {{ row.text }}
                            </div> 
                    </div>
                </div>

            </div>
            <div v-else class="text-danger text-center font-size-16 mt-3" > 
                {{ $t("reporting.noData") }}
            </div>



            <div  class="row mt-3">
                <div class="col-3"/>
                <div class="col-3">
                    <b-button variant="primary" class="mr-2 ml-2 text-uppercase" @click="exportCollectedData()" :disabled="this.pagemodel.totalRows == 0" >
                         {{ $t("buttons.export") }}
                    </b-button>
                </div>
                <div class="col-3 mr-2 ml-sm-2 ml-4">
                    <b-button variant="outline-secondary"  @click="showModal = false" >
                        {{ $t("buttons.cancel") }}
                    </b-button>
                </div>
                <div class="col-3"/>
            </div>
    </b-modal>
    </div>

</template>

<style scoped>
::v-deep thead {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;}
</style>










